import React, { useState } from "react";
import { GetFeed } from "graphql/configuration/queries/GetFeed";
import { FeedType } from "utility/constants";
import { useQuery } from "hooks/useQuery";
import PersonalFeed from "components/feedComponents/PersonalFeed";
import LikesFeed from "components/feedComponents/LikesFeed";
import Loading from "components/loadingComponents/BouncingLoader";
import NoSnacksFound from "components/feedComponents/NoSnacksFound";

export default function FeedTab({ user }) {
  const [tab, setTab] = useState("FEED");

  return (
    <div className="flex w-full lg:w-[1200px] max-w-full flex-col mx-auto">
      <Tabs setTab={setTab} tab={tab} />
      {user.isPrivate ? (
        <NoSnacksFound />
      ) : (
        <FeedContainer tab={tab} user={user} />
      )}
    </div>
  );
}

function FeedContainer({ tab, user }) {
  const userFeedData = useQuery(GetFeed, {
    variables: {
      feedType: FeedType.USER,
      user,
    },
    fetchPolicy: "cache-and-network",
  });
  // user likes feed //
  const userLikesFeedData = useQuery(GetFeed, {
    variables: {
      feedType: FeedType.LIKED,
      user,
    },
    fetchPolicy: "cache-and-network",
  });

  if (userFeedData.loading || userLikesFeedData.loading)
    return (
      <div className="w-full flex flex-col items-center lg:flex-wrap lg:flex-row overflow-x-hidden mt-4 py-4">
        <Loading />
      </div>
    );
  return (
    <div className="w-full flex flex-col items-center lg:flex-wrap lg:flex-row overflow-x-hidden justify-center">
      {tab === "FEED" && (
        <PersonalFeed userFeedData={userFeedData} user={user} />
      )}
      {tab === "LIKED" && (
        <LikesFeed userLikesFeedData={userLikesFeedData} user={user} />
      )}
    </div>
  );
}

function Tabs({ tab, setTab }) {
  return (
    <div className="max-w-full w-[340px] lg:w-full mx-auto flex lg:px-4 ">
      <div
        aria-hidden
        onClick={() => setTab("FEED")}
        className={
          tab === "FEED"
            ? `py-2 flex-1 flex justify-center border-b-2 border-[#21252A] font-semibold cursor-pointer`
            : `py-2 flex-1 flex justify-center border-b-2 border-gray-200 font-semibold cursor-pointer`
        }
      >
        <span>Snacks</span>
      </div>
      <div
        aria-hidden
        onClick={() => setTab("LIKED")}
        className={
          tab === "LIKED"
            ? `py-2 flex-1 flex justify-center border-b-2 border-[#21252A] font-semibold cursor-pointer`
            : `py-2 flex-1 flex justify-center border-b-2 border-gray-200 font-semibold cursor-pointer`
        }
      >
        <span>Liked</span>
      </div>
    </div>
  );
}
